import t from "../../theme";

export const useGetProfileScreenStyles = () => {
  return {
    titleBanner: {
      height: 50,
      background: "#2e7d32",
      marginBottom: 16,
      display: "flex",
      alignItems: "center",
      padding: "0 40px",
      justifyContent: "space-between",
      color: t.brand.white,
      position: "relative",
      boxShadow: "0 4px 20px rgba(46, 125, 50, 0.25)",
      "& h1": {
        color: "inherit",
        fontSize: "18px",
        fontWeight: 600,
        letterSpacing: "0px",
        margin: 0,
        textShadow: "0 2px 4px rgba(0,0,0,0.1)",
      },
      "@media (max-width: 768px)": {
        height: 44,
        padding: "0 16px",
        "& h1": {
          fontSize: "15px",
        },
      },
    },
    backButtonWrapper: {
      zIndex: 1,
      display: "flex",
      alignItems: "center",
    },
    signUpFormContainer: {
      display: "flex",
      gap: 24,
      maxWidth: "900px",
      justifyContent: "center",
      margin: "0 auto 60px",
      padding: "0 20px",
      "@media (max-width: 768px)": {
        maxWidth: "100%",
        gap: 16,
        padding: "0 12px",
      },
    },
    signupForm: {
      width: "100%",
      maxWidth: 720,
      display: "flex",
      gap: 0,
      flexDirection: "column",
      alignItems: "center",
      "@media (max-width: 768px)": {
        gap: 0,
      },
    },
    avatarSection: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 12,
      marginBottom: 24,
    },
    avatarWrapper: {
      position: "relative",
      padding: 3,
      background: t.green.gradient,
      borderRadius: "50%",
      boxShadow: "0 4px 16px rgba(46, 125, 50, 0.25)",
      transition: t.transition.smooth,
      "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: "0 6px 20px rgba(46, 125, 50, 0.35)",
      },
    },
    userInfoPill: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 2,
      background: t.glass.primary,
      backdropFilter: t.blur.heavy,
      WebkitBackdropFilter: t.blur.heavy,
      padding: "8px 24px",
      borderRadius: t.radius.pill,
      border: "1px solid rgba(46, 125, 50, 0.12)",
      boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
    },
    userName: {
      fontSize: "1.05rem",
      fontWeight: 600,
      color: t.text.primary,
      letterSpacing: "0.2px",
    },
    userEmail: {
      fontSize: "0.8rem",
      color: t.text.muted,
    },
    formFieldsWrapper: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: 20,
    },
    sectionCard: {
      width: "100%",
      background: t.glass.primary,
      backdropFilter: t.blur.heavy,
      WebkitBackdropFilter: t.blur.heavy,
      borderRadius: t.radius.lg,
      padding: "24px 28px",
      boxShadow:
        "0 4px 16px rgba(46, 125, 50, 0.06), 0 1px 3px rgba(0,0,0,0.04)",
      border: "1px solid rgba(46, 125, 50, 0.1)",
      transition: t.transition.smooth,
      "&:hover": {
        boxShadow:
          "0 6px 20px rgba(46, 125, 50, 0.08), 0 2px 6px rgba(0,0,0,0.05)",
      },
      "@media (max-width: 768px)": {
        padding: "18px 16px",
        borderRadius: t.radius.md,
      },
    },
    sectionTitle: {
      fontSize: "15px",
      fontWeight: 600,
      color: t.text.primary,
      marginBottom: "18px",
      marginTop: 0,
      display: "flex",
      alignItems: "center",
      gap: "8px",
      "&::before": {
        content: '""',
        width: "3px",
        height: "18px",
        background: t.green.gradient,
        borderRadius: "2px",
      },
    },
    formFieldsGroup: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: 18,
    },
    footerBtn: {
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      marginTop: 24,
    },
    formFieldsFlexGroup: {
      width: "100%",
      display: "flex",
      gap: 16,
      margin: "0px",
      "@media (max-width: 768px)": {
        flexDirection: "column",
        gap: 14,
      },
    },
    textField: {
      "& .MuiOutlinedInput-root": {
        borderRadius: t.radius.md,
        backgroundColor: "rgba(255, 255, 255, 0.65)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
        transition: t.transition.fast,
        minHeight: "44px",
        "& fieldset": {
          borderColor: "rgba(46, 125, 50, 0.12)",
          borderWidth: "1px",
          transition: t.transition.fast,
        },
        "&:hover:not(.Mui-disabled)": {
          backgroundColor: "rgba(255, 255, 255, 0.85)",
        },
        "&:hover:not(.Mui-disabled) fieldset": {
          borderColor: "rgba(46, 125, 50, 0.4)",
        },
        "&.Mui-focused": {
          backgroundColor: t.brand.white,
        },
        "&.Mui-focused fieldset": {
          borderColor: "#2e7d32",
          borderWidth: "2px",
        },
        "&.Mui-disabled": {
          backgroundColor: "rgba(255, 255, 255, 0.5)",
          backdropFilter: "blur(6px)",
          WebkitBackdropFilter: "blur(6px)",
        },
        "&.Mui-disabled fieldset": {
          borderColor: "rgba(46, 125, 50, 0.08)",
          borderStyle: "solid",
        },
      },
      "& .MuiInputLabel-root": {
        color: t.text.muted,
        fontWeight: 400,
        fontSize: "0.9rem",
        transition: t.transition.fast,
        "&.MuiInputLabel-shrink": {
          fontSize: "0.82rem",
          fontWeight: 500,
          color: t.text.secondary,
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          padding: "1px 8px",
          borderRadius: "10px",
          marginLeft: "-2px",
          border: "1px solid rgba(46, 125, 50, 0.12)",
        },
        "&.Mui-focused": {
          color: t.brand.white,
          fontWeight: 500,
        },
        "&.MuiInputLabel-shrink.Mui-focused": {
          backgroundColor: "#2e7d32",
          color: t.brand.white,
          padding: "1px 8px",
          borderRadius: "10px",
          border: "1px solid #2e7d32",
        },
        "&.Mui-disabled": {
          color: t.text.muted,
          "&.MuiInputLabel-shrink": {
            color: t.text.secondary,
            backgroundColor: "rgba(255, 255, 255, 0.85)",
            border: "1px solid rgba(46, 125, 50, 0.08)",
          },
        },
      },
      "& .MuiOutlinedInput-input": {
        padding: "14px 14px",
        fontSize: "0.92rem",
        lineHeight: "1.4375em",
        color: t.text.primary,
        "&.Mui-disabled": {
          WebkitTextFillColor: t.text.secondary,
          color: t.text.secondary,
        },
      },
    },
  };
};
